import { ResolverTag } from '@ps/web-core-enums';
import { CrossPlatformLink, useResolver } from '@ps/web-shared-components';
import React from 'react';

import CMSHTML from '../../../../../CMSHTML/CMSHTML';
import CMSImage from '../../../../../CMSImage/CMSImage';
import type { Props } from '../../TopHeader';

import styles from './RegulatoryHeaderCH.scss';

const RegulatoryHeaderCZ: React.FC<Props> = ({
  regulatory_header: [
    {
      texts: [{ content }],
      icons: [icon]
    }
  ]
}) => {
  const davosUrl = useResolver(ResolverTag.Davos);

  return (
    <div className={styles.regulatoryHeader}>
      <div className={styles.translation}>
        <CMSHTML content={content} />
      </div>
      <CrossPlatformLink href={davosUrl} openLinkInNewTab>
        <CMSImage className={styles.regulatoryIcon} {...icon} />
      </CrossPlatformLink>
    </div>
  );
};

export default RegulatoryHeaderCZ;
